import { installDevErrorReporter } from './error-reporter'

export { installDevErrorReporter }

// 自动注入 — 两个独立触发条件:
//   1. import.meta.env.DEV         — 本地 vite dev server(`pnpm dev`)开发模式
//   2. import.meta.env.VITE_DEV_REPORTER === 'true' — L5 production build 显式开启
//      (devstack docker-compose build args 注入,prod CI 不注入)
// 任一为真且非 SSR 环境就装 hook;否则 tree-shake 掉(VITE_DEV_REPORTER 常量在 vite
// 构建时折叠成 string literal,'' === 'true' 是 false → if 整块 dead code →
// rollup 把 import 和 installDevErrorReporter 都摇掉,生产 0 运行时开销)。
//
// **必须是 static import + sync call**(不是 dynamic import)— 因为 main.tsx 可能在
// shared 加载完后立刻同步抛错(如 import.meta.env VITE_SUPABASE_PUBLISHABLE_KEY 缺失);
// dynamic import 让 hook 注册延迟到下一个微任务,错过同步 throw,Uncaught 不进 /__dev/log。
// 2026-05-24 实测踩坑后改 static。
//
// 4 个 SPA 各自 import @dogdisk/shared 时这段会跑;无需在 main.tsx 手动调用。
//
// shared lib 不依赖 vite/client 类型,用 (import.meta as any).env 兼容
// 浏览器 / SSR / vitest / jest 几种宿主环境(测试环境 .env 取不到 → undefined → 跳过)。
const _meta = import.meta as { env?: { DEV?: boolean; VITE_DEV_REPORTER?: string } }
const _envOn = _meta.env?.DEV === true || _meta.env?.VITE_DEV_REPORTER === 'true'
if (_envOn && typeof window !== 'undefined') {
  installDevErrorReporter()
}
